import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "orNotAvail" })
export class OrNotAvailPipe implements PipeTransform {
    transform(value: any): string {
        if (!!value) {
            return value;
        } else {
            return "—";
        }
    }
}
